var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36796 15C4.34609 15 2.46136 14.4119 0.875 13.3973C2.22187 13.4844 4.59879 13.2757 6.07724 11.8655C3.85317 11.7634 2.85016 10.0577 2.71934 9.32873C2.90831 9.40162 3.80956 9.4891 4.31834 9.28499C1.75994 8.64351 1.36745 6.39833 1.45467 5.71311C1.93437 6.04843 2.74841 6.16506 3.06821 6.1359C0.684246 4.43015 1.54189 1.86422 1.96345 1.31022C3.67426 3.68042 6.23825 5.01161 9.41024 5.08565C9.35043 4.82335 9.31885 4.55026 9.31885 4.26978C9.31885 2.25682 10.9459 0.625 12.9529 0.625C14.0016 0.625 14.9465 1.07047 15.6098 1.78302C16.3106 1.61882 17.3652 1.23442 17.8808 0.902003C17.6209 1.83507 16.8118 2.61343 16.3224 2.90192C16.3265 2.91174 16.3185 2.89207 16.3224 2.90192C16.7523 2.8369 17.9155 2.61336 18.375 2.3016C18.1478 2.82578 17.29 3.69733 16.5861 4.18526C16.717 9.96129 12.2978 15 6.36796 15Z",
    fill: "#47ACDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.06f47fd276039b654e90d3269c7d104a.svg";
export { ForwardRef as ReactComponent };